import { useAppSelector } from "../../app/hooks";
import { UserPermissionLevel } from "../../config/constants";
import { hasReadAccess, hasWriteAccess } from "../../store/permissionSlice";

type ProtectedByRoleProps = {
  pageKey: string;
  roleType: UserPermissionLevel;
  children: React.ReactNode;
  fallBackComponent?: React.ReactNode;
};

const ProtectedComponentByRole = ({ pageKey, roleType, children, fallBackComponent }: ProtectedByRoleProps) => {
  const pageRoles = useAppSelector(state => state.permissions.pageRoles) ?? {};
  const userRoles: string[] = pageRoles[pageKey] ?? [];

  let hasRole = false;
  if (roleType === UserPermissionLevel.Read) {
    hasRole = hasReadAccess(userRoles);
  } else if (roleType === UserPermissionLevel.Write) {
    hasRole = hasWriteAccess(userRoles);
    }
    
  if (!hasRole) {
    return <>{fallBackComponent}</>;
  }

  return <>{children}</>;
};

export default ProtectedComponentByRole;
